// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendarGridYear_wrap{
    overflow-y: scroll;
    height: 100%;
}

.calendarGridYear_header {
    padding: 10px 0;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 15px;
    position: sticky;
    top: 0;
    background: white;
    z-index: 10;
}

.calendarGridYear_date {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin: 0;
}

.calendarGridYear{
    display: flex;
    flex-wrap: wrap;
    --cols: 4;
    --gap: 18px;
    gap: var(--gap);
}

.calendarGridYear_month{
    width: calc((100% - var(--gap) * (var(--cols) - 1)) / var(--cols));
}

.calendarGridYear_month_name{
    font-size: calc(12px * var(--fontScaler));
    font-weight: 500;
    padding: 5px 2px;
}

.calendarGridYear_month_dates{
    display: flex;
    flex-wrap: wrap;
    --cols: 7;
    --gap: 0px;
}

.calendarGridYear_month_day{
    width: calc((100% - var(--gap) * (var(--cols) - 1)) / var(--cols));
    font-size: calc(9px * var(--fontScaler));
    padding: 5px 2px;
    position: relative;

    display: flex;
    justify-content: center;
    border-radius: 3px;
}

.calendarGridYear_month_day_number{
    position: relative;
}

.calendarGridYear_month_day--name{
    font-size: calc(7px * var(--fontScaler));
    font-weight: 700;
}

.calendarGridYear_dayWithTicket{
    position: absolute;
    /*width: 100%;*/
    height: 100%;
    top: 0;
    /*left: 0;*/
    background-color: #FFA825;
    font-size: 0;

    aspect-ratio: 1;
    border-radius: 100%;
}

.calendarGridYear_month_day_clickable:hover{
    /*background-color: #f6f6f9;*/
    background-color: #f9f9f6;
}
`, "",{"version":3,"sources":["webpack://./src/components/calendarGrid/CalendarGridYear.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kEAAkE;IAClE,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;;IAElB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,MAAM;IACN,WAAW;IACX,yBAAyB;IACzB,YAAY;;IAEZ,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B","sourcesContent":[".calendarGridYear_wrap{\n    overflow-y: scroll;\n    height: 100%;\n}\n\n.calendarGridYear_header {\n    padding: 10px 0;\n    border-bottom: 1px solid #e0e0e0;\n    margin-bottom: 15px;\n    position: sticky;\n    top: 0;\n    background: white;\n    z-index: 10;\n}\n\n.calendarGridYear_date {\n    font-size: 24px;\n    font-weight: 600;\n    color: #333;\n    margin: 0;\n}\n\n.calendarGridYear{\n    display: flex;\n    flex-wrap: wrap;\n    --cols: 4;\n    --gap: 18px;\n    gap: var(--gap);\n}\n\n.calendarGridYear_month{\n    width: calc((100% - var(--gap) * (var(--cols) - 1)) / var(--cols));\n}\n\n.calendarGridYear_month_name{\n    font-size: calc(12px * var(--fontScaler));\n    font-weight: 500;\n    padding: 5px 2px;\n}\n\n.calendarGridYear_month_dates{\n    display: flex;\n    flex-wrap: wrap;\n    --cols: 7;\n    --gap: 0px;\n}\n\n.calendarGridYear_month_day{\n    width: calc((100% - var(--gap) * (var(--cols) - 1)) / var(--cols));\n    font-size: calc(9px * var(--fontScaler));\n    padding: 5px 2px;\n    position: relative;\n\n    display: flex;\n    justify-content: center;\n    border-radius: 3px;\n}\n\n.calendarGridYear_month_day_number{\n    position: relative;\n}\n\n.calendarGridYear_month_day--name{\n    font-size: calc(7px * var(--fontScaler));\n    font-weight: 700;\n}\n\n.calendarGridYear_dayWithTicket{\n    position: absolute;\n    /*width: 100%;*/\n    height: 100%;\n    top: 0;\n    /*left: 0;*/\n    background-color: #FFA825;\n    font-size: 0;\n\n    aspect-ratio: 1;\n    border-radius: 100%;\n}\n\n.calendarGridYear_month_day_clickable:hover{\n    /*background-color: #f6f6f9;*/\n    background-color: #f9f9f6;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
